export default __webpack_public_path__ + "static/media/trees-in-forest-during-sunset-247421.3c788ccf.jpg";